import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import MaterialTable from 'material-table'
import axios from 'axios'
import { get } from 'lodash'

export default function MissingTitlesList(props) {
    
    const [missingTitles, setMissingTitles] = useState([])
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios(`/api/missing_job_titles`)
				setMissingTitles(result.data.data)
            } catch (e) {
                setMissingTitles([])
            }
        }
        fetchData()
    }, [props.dataVersion])

    return (
        <Box m={2} display="flex" justifyContent="center">
            <MaterialTable
                title=''
                columns={[
                    { title: `Company's Job Title`, field: 'company_job_title' },
                    {
                        title: 'CompKit Standard Job Title',
                        field: 'radfordJobCode.job_title',
                        render: rowData => {
                            const rd = rowData.radfordJobCode
                            if(rowData.compkit_job_code_list_id){
                                return `${rd.job_title}  (${rd.job_category}${rd.job_level})`
                            } else {
                                return ''
                            }
                        }
                    },
                ]}
                data={missingTitles}
                actions={[
                    {
                        icon: 'help',
                        tooltip: 'Help me',
                        onClick: (event, rowData) => {
                            console.log(rowData)
                            if(rowData.company_job_title !== null){
                                const selection = {
                                    companyJobTitle: rowData.company_job_title,
                                    compkitJobCodeListId: rowData.compkit_job_code_list_id,
                                    compkitJobTitle: get(rowData, 'radfordJobCode.job_title', ''),
                                }
                                props.onTitleSelection(selection)
                            }else{
                                props.showErrorMessage('Please fill the "Job Title" field')
                            }
                        },
                    },
                ]}
                options={{
                    actionsColumnIndex: -1,
                }}
            />
        </Box>
    )
}

MissingTitlesList.propTypes = {
	onTitleSelection: PropTypes.func.isRequired,
}
